import { NavigateFunction } from 'react-router-dom'
import { findTaskOverviewViewContainingItem } from './overview'
import { TOverviewView } from './types'

const navigateToNextItemAfterOverviewCompletion = (
    oldLists: TOverviewView[],
    newLists: TOverviewView[],
    deletedTaskId: string,
    navigate: NavigateFunction
) => {
    const location = window.location.pathname.split('/')
    const navigateToOverview = () => navigate('/overview/')

    // Get list with deleted task
    const listWithDeletedTask = findTaskOverviewViewContainingItem(oldLists, deletedTaskId)

    // If list has more than one task, navigate to next task
    if (listWithDeletedTask && listWithDeletedTask.view_item_ids.length !== 1) {
        if (location[3] !== deletedTaskId) return
        const taskIndex = listWithDeletedTask.view_item_ids.findIndex((id) => id === deletedTaskId)
        const remainingIds = new Set(newLists.find((list) => list.id === listWithDeletedTask.id)?.view_item_ids)
        const nextTaskId = listWithDeletedTask.view_item_ids.slice(taskIndex + 1).find((id) => remainingIds.has(id))
        if (nextTaskId) {
            navigate(`/overview/${listWithDeletedTask.id}/${nextTaskId}`)
        } else {
            const previousTaskId = listWithDeletedTask.view_item_ids
                .slice(0, taskIndex)
                .reverse()
                .find((id) => remainingIds.has(id))
            if (previousTaskId) navigate(`/overview/${listWithDeletedTask.id}/${previousTaskId}`)
            else navigateToOverview()
        }
    } else {
        // AccordionItem owns the empty-card handoff and desktop task selection so both use the
        // filtered cards and respect any other cards the user opened.
        navigateToOverview()
    }
}
export default navigateToNextItemAfterOverviewCompletion
